import { createContext } from 'react';

export interface PictureContextProps {
	imageContextKey: string;
	onImageZoomStart: () => void;
}

export const PictureContext = createContext<PictureContextProps>(null!);